import { Component, OnInit, Self, Optional, Input, HostListener, ChangeDetectionStrategy } from '@angular/core';
import { BaseInputComponent } from '../base-input';
import { NgControl } from '@angular/forms';
import { FieldConventionService, ValidationMessageService } from 'src/app/stp/stp-app/forms';

@Component({
  selector: 'stp-input-number',
  templateUrl: './input-number.component.html'
})
export class InputNumberComponent extends BaseInputComponent implements OnInit {

  private digitRegEx: RegExp = new RegExp('^[0-9]*$');
  private allowedKeys: Array<string> = [ 'Backspace', 'Delete', 'ArrowRight', 'ArrowLeft', 'ArrowUp', 'ArrowDown', 'Tab', 'End', 'Home' ];

  @Input() step = 1;
  @Input() min?: number;
  @Input() max?: number;
  @Input() decimal: false;

  constructor(@Optional() @Self() ngControl: NgControl,
    fieldConventionService: FieldConventionService,
    validationMessageService: ValidationMessageService) {
    super(ngControl, fieldConventionService, validationMessageService);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  registerOnChange(fn: any) {
    super.registerOnChange((value: string) => {
      if (value === '') {
        fn(null);
      } else {
        fn(+value);
      }
    });
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (!this.decimal) {
      this.isIntegerKey(event);
    }
  }

  private isIntegerKey(event: KeyboardEvent) {
    if (this.allowedKeys.indexOf(event.key) !== -1) {
      return;
    }

    const current: string = this.matInput.value;
    // create potential new field value
    const next: string = current.concat(event.key);

    // non-number key press guard
    if (next && !String(next).match(this.digitRegEx)) {
      event.preventDefault();
    }

    // max guard
    if (this.max && parseInt(next, 10) > this.max) {
      event.preventDefault();
    }
  }
}
